"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnrollmentApplicationStatus = exports.EnrollmentFormMembershipType = exports.EnrollmentFormStatus = exports.EnrollmentFormTypeEnum = void 0;
var EnrollmentFormTypeEnum;
(function (EnrollmentFormTypeEnum) {
    EnrollmentFormTypeEnum[EnrollmentFormTypeEnum["DEFAULT"] = 0] = "DEFAULT";
    EnrollmentFormTypeEnum[EnrollmentFormTypeEnum["MEMBERSHIP"] = 1] = "MEMBERSHIP";
})(EnrollmentFormTypeEnum = exports.EnrollmentFormTypeEnum || (exports.EnrollmentFormTypeEnum = {}));
var EnrollmentFormStatus;
(function (EnrollmentFormStatus) {
    EnrollmentFormStatus[EnrollmentFormStatus["ACTIVE"] = 0] = "ACTIVE";
    EnrollmentFormStatus[EnrollmentFormStatus["DISABLED"] = 1] = "DISABLED";
    EnrollmentFormStatus[EnrollmentFormStatus["DELETED"] = 2] = "DELETED";
})(EnrollmentFormStatus = exports.EnrollmentFormStatus || (exports.EnrollmentFormStatus = {}));
var EnrollmentFormMembershipType;
(function (EnrollmentFormMembershipType) {
    EnrollmentFormMembershipType[EnrollmentFormMembershipType["MEMBER"] = 0] = "MEMBER";
    EnrollmentFormMembershipType[EnrollmentFormMembershipType["OTHER"] = 1] = "OTHER";
})(EnrollmentFormMembershipType = exports.EnrollmentFormMembershipType || (exports.EnrollmentFormMembershipType = {}));
/** Status for how far in the application stage application is */
var EnrollmentApplicationStatus;
(function (EnrollmentApplicationStatus) {
    EnrollmentApplicationStatus[EnrollmentApplicationStatus["WAITING_FOR_APPROVAL"] = 0] = "WAITING_FOR_APPROVAL";
    EnrollmentApplicationStatus[EnrollmentApplicationStatus["APPROVED"] = 1] = "APPROVED";
    EnrollmentApplicationStatus[EnrollmentApplicationStatus["DELETED"] = 2] = "DELETED";
})(EnrollmentApplicationStatus = exports.EnrollmentApplicationStatus || (exports.EnrollmentApplicationStatus = {}));
//# sourceMappingURL=enrollment.js.map